/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index';

let exports = {};

// 增加询盘单
exports.saveDealInqryVoucher = function (postData, callback) {// 保存询盘单
    api.post('/deal/inqry/voucher/save/do')
    .data(postData)
    .done(callback)
    .go();
};

// 查询询盘单
exports.getDealInqryVoucherList = function (postData, callback) {// 获取询盘单列表
    api.post('/deal/inqry/voucher/list/get')
    .data(postData)
    .done(callback)
    .go();
};

//根据询盘单id查询询盘
exports.getDealInqryVoucher = function (postData, callback) {// 获取询盘单
    api.post('/deal/inqry/voucher/get')
    .data(postData)
    .done(callback)
    .go();
};

//申请询盘单
exports.applyDealInqryVoucher = function (postData, callback) {// 申请询盘单
    api.post('/deal/inqry/voucher/apply/do')
    .data(postData)
    .done(callback)
    .go();
};

//审核询盘单
exports.auditDealInqryVoucher = function (postData, callback) {// 审核询盘单
    api.post('/deal/inqry/voucher/audit/do')
    .data(postData)
    .done(callback)
    .go();
};

//发布询盘单
exports.publishDealInqryVoucher = function (postData, callback) {// 发布询盘单
    api.post('/deal/inqry/voucher/publish/do')
    .data(postData)
    .done(callback)
    .go();
};

// 询盘单结束操作
exports.doDealInqryVoucherFinished = function (postData, callback) {// 发布询盘单
    api.post('/deal/inqry/voucher/finished/do')
    .data(postData)
    .done(callback)
    .go();
};

//关闭询盘单
exports.closeDealInqryVoucher = function (postData, callback) {// 关闭询盘单
    api.post('/deal/inqry/voucher/close/do')
    .data(postData)
    .done(callback)
    .go();
};

//删除询盘单
exports.deleteDealInqryVoucher = function (postData, callback) {// 删除询盘
    api.post('/deal/inqry/voucher/delete/do')
    .data(postData)
    .done(callback)
    .go();
};

//修改询盘单tag
exports.updateDealInqryVoucher = function (postData, callback) {// 更新询盘单
    api.post('/deal/inqry/voucher/update/do')
    .data(postData)
    .done(callback)
    .go();
};

//报盘单列表
exports.getDealReplyVoucherList = function (postData, callback) {// 查询报盘单列表
    api.post('/deal/reply/voucher/list/get')
    .data(postData)
    .done(callback)
    .go();
};

//更新询盘单
exports.closeDealInqryVoucherExpired = function (postData, callback) {// 关闭所有过期询盘单
    api.post('/deal/inqry/voucher/expired/close/do')
    .data(postData)
    .done(callback)
    .go();
};

///取消询盘单来源
exports.cancelDealInqryVoucherSrc = function (postParam, callback) {// 更新询价单
    api.post('/deal/inqry/voucher/src/cancel/do')
    .params(postParam)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/deal.js
// module id = 133
// module chunks = 0